module.exports = __webpack_public_path__ + "img/wait_shipping.a610d117.svg";